<template>
  <div class="table-screes">
    <div class="screes-titel">
      <h2>筛选</h2>
      <img src="../../../../static/images/close.png" class="closeicon" @click="closeClick">
    </div>
    <div class="screes-warpper">
      <van-collapse v-model="activeName" accordion @change="getName()">
        <van-collapse-item title="区" v-if="isHeadCompany()" name="0">
          <div class="itemBut">
            <van-button
            :class="{'itemButListH':selectTypeArr.indexOf(area.areaId)!=-1}"
            type="info"
            v-for="(area, areaIndex) in areas" :key="areaIndex"
            @click="itemButClick(area)">
            {{area.areaName}}
            </van-button>
          </div>
        </van-collapse-item>
        <!-- 区 end-->
        <van-collapse-item name="1">
          <div slot="title">
            机构
            <div v-show="textShow" class='text'>{{showText}}</div>
          </div>
          <MyTreeSelect ref="treeSelect" :filterType="'branch'" :items="branchs" v-on:chooseData1='getData1' v-on:chooseData2='getData2'></MyTreeSelect>
        </van-collapse-item>
        <van-collapse-item :title="(otherFiler.achievementName.indexOf('(')!=-1)?(otherFiler.achievementName.substring(0, otherFiler.achievementName.indexOf('('))):otherFiler.achievementName" name="2" class="inputBox">
          <van-cell-group>
            <van-field v-model="reachObj.reachMin" :placeholder="'最低('+otherFiler.achievementUnit+')'" />
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="reachObj.reachMax" :placeholder="'最高('+otherFiler.achievementUnit+')'" />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item :title="(otherFiler.completionRateName.indexOf('(')!=-1)?(otherFiler.completionRateName.substring(0, otherFiler.completionRateName.indexOf('('))):otherFiler.completionRateName" name="3" class="inputBox" v-if="timeIndex === 3 && showFlag.hasAchievementRate && TopHundredData === 1">
          <van-cell-group>
            <van-field v-model="rateObj.rateMin" :placeholder="'最低('+otherFiler.completionRateUnit+')'" />
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="rateObj.rateMax" :placeholder="'最高('+otherFiler.completionRateUnit+')'" />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="占比" name="4" class="inputBox" v-if="timeIndex === 3 && showFlag.hasAccountFor && TopHundredData === 1">
          <van-cell-group>
            <van-field v-model="ratioObj.ratioMin" :placeholder="'最低(%)'" />
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="ratioObj.ratioMax" :placeholder="'最高(%)'" />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item :title="(otherFiler.comparedWithName.indexOf('(')!=-1)?(otherFiler.comparedWithName.substring(0, otherFiler.comparedWithName.indexOf('('))):otherFiler.comparedWithName" name="5" class="inputBox" v-if="timeIndex === 3 && compareShow">
          <van-cell-group>
            <van-field v-model="compareObj.compareMin" :placeholder="'最低('+otherFiler.comparedWithUnit+')'" />
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="compareObj.compareMax" :placeholder="'最高('+otherFiler.comparedWithUnit+')'" />
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="screes-footer">
      <button @click="clearSelectedBranchs">重置</button>
      <button @click="childClick">确定</button>
    </div>
  </div>

</template>

<script>
import MyTreeSelect from './MyTreeSelect'
import { postAction, getAction } from '@/utils/api'
export default {
  name: 'TablesScreens',
  components: {
    MyTreeSelect
  },
  props: ['timeIndex', 'otherFiler', 'calendarData'],
  data () {
    return {
      areas: [
        {areaName: '东区', areaSName: '东', areaId: '861'},
        {areaName: '南区', areaSName: '南', areaId: '862'},
        {areaName: '西区', areaSName: '西', areaId: '863'},
        {areaName: '北区', areaSName: '北', areaId: '864'}
      ],
      selectTypeArr: [], // 选中的机构id  数组
      compareShow: false,
      areaShowText: '',
      checkedArea: [],
      TopHundredData: 1,
      childByValue: false,
      type: '',
      childValue: false,
      activeName: '0',
      branchs: [],
      branchsCopy: [],
      orgBranchs: [],
      products: [],
      rates: {},
      sliderValue: [],
      sliderTick: [],
      firstLevel: [], // 一级内容
      secondLevel: [], // 二级内容
      showText: '',
      textShow: false,
      postChannel: '',
      postKind: '',
      postTime: '',
      postQuota: '',
      showFlag: '',
      reachObj: {
        reachMin: '',
        reachMax: ''
      },
      compareObj: {
        compareMin: '',
        compareMax: ''
      },
      rateObj: {
        rateMin: '',
        rateMax: ''
      },
      ratioObj: {
        ratioMin: '',
        ratioMax: ''
      },
      itemButText: [],
      itemListNewFlag: [], // 存储取消选择容器
      array: []
    }
  },
  methods: {
    getCompareShow () {
      const quota = this.$store.state.entirety.quota
      if (quota.charAt(0) === 'B') {
        this.compareShow = false
      } else {
        this.compareShow = true
      }
    },
    isHeadCompany () {
      return this.$store.state.user.orgId === '86' && this.$store.state.user.areaFlag === '0' && this.$store.state.user.level === '1' && this.$store.state.user.pageCode === '02'
    },
    changeTopHundred () {
      let postData = {
        'channelId': this.postChannel,
        'classification': this.postKind,
        'dateType': this.postTime,
        'indexId': [this.postQuota],
        'date': this.calendarData || '',
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId
      }
      var obj = null
      if (this.TopHundredData === 2) {
        console.log('百强中支')
        obj = postAction('/simpapp/Filtrate/getTopHundredList', postData)
      } else {
        console.log('分公司')
        obj = postAction('/performance/Filtrate/getList', postData)
      }
      obj.then(this.getFilterData)
    },
    clearSelectedBranchs () {
      // 切换头部渠道初始化筛选弹框区的选中状态
      for (let index = 0; index < this.areas.length; index++) {
        if (this.areas[index].checked) {
          this.areas[index].checked = false
        }
      }
      this.branchs = JSON.parse(JSON.stringify(this.branchsCopy))
      this.selectTypeArr = [] // 清空区回显
      this.checkedArea = this.selectTypeArr // 机构分析筛选条件单选机构在切换渠道后未初始化，此处添加初始化
      this.showText = '' // 清空城市名称回显
      this.textShow = false
      this.reachObj = {
        reachMin: '',
        reachMax: ''
      }
      this.compareObj = {
        compareMin: '',
        compareMax: ''
      }
      this.rateObj = {
        rateMin: '',
        rateMax: ''
      }
      this.ratioObj = {
        ratioMin: '',
        ratioMax: ''
      }
      if (this.firstLevel.length > 0 || this.secondLevel.length > 0) {
        this.$refs.treeSelect.clearConditions()
      }
      if (this.isHeadCompany()) {
        this.activeName = '0'
      } else {
        this.activeName = ''
      }
    },
    getName (activeNames) {
      this.showText = ''
      if (!this.activeName) {
        this.textShow = false
      } else {
        let firstLevel = Object.values(this.$refs.treeSelect.selected1)
        let secondLevel = Object.values(this.$refs.treeSelect.selected2)
        if (firstLevel.length > 0) {
          for (let i = 0; i < firstLevel.length; i++) {
            let chooseParent = firstLevel[i].orgCode
            let chooseChild = []
            if (secondLevel.length > 0) {
              for (let j = 0; j < secondLevel.length; j++) {
                if (secondLevel[j].parentId === chooseParent) {
                  chooseChild.push(secondLevel[j])
                }
              }
            }
            this.showText = this.showText + '' + firstLevel[i].orgSname
            if (chooseChild.length > 0) {
              for (let i = 0; i < chooseChild.length; i++) {
                if (i === 0) {
                  this.showText = this.showText + '-' + chooseChild[i].orgSname
                } else {
                  this.showText = this.showText + '、' + chooseChild[i].orgSname
                }
              }
            }
            this.showText = this.showText + ';'
          }
        }
        if (this.showText !== '') {
          console.log(this.showText)
          this.textShow = true
        }
      }
    },
    childClick () { // 确定提交
      this.$emit('childByValue', this.childValue, this.firstLevel, this.secondLevel, this.reachObj, this.compareObj, this.rateObj, this.ratioObj, this.checkedArea)
    },
    // 点击区域
    itemButClick (itemBut) {
      // 选中的数据添加checked
      this.$set(itemBut, 'checked', !itemBut.checked)
      // 判断是否被选中
      if (itemBut.checked) {
        // 被选中
        this.selectTypeArr.push(itemBut.areaId)
        this.selectTypeArr = [...new Set(this.selectTypeArr)]
      } else {
        for (let i = 0; i < this.selectTypeArr.length; i++) {
          if (this.selectTypeArr[i] === itemBut.areaId) {
            this.selectTypeArr.splice(i, 1)
          }
        }
      }
      this.checkedArea = this.selectTypeArr
      if (this.checkedArea.length > 0) {
        let result = JSON.parse(JSON.stringify(this.orgBranchs)).filter(item => {
          if (this.checkedArea.includes(JSON.stringify(item.areaCode))) {
            return item
          }
        })
        this.branchs = result
      } else {
        this.branchs = this.orgBranchs
      }
    },
    closeClick () {
      this.$emit('childByValue', this.childValue)
    },
    // 选择区后添加机构列
    // 将区信息同步到机构数据中
    getFilterData (data) {
      if (data.data) {
        this.orgBranchs = [...data.data]
        if (this.checkedArea.length === 0) {
          this.branchs = [...this.orgBranchs]
        } else {
          this.branchs = JSON.parse(JSON.stringify(this.orgBranchs)).filter(branch => this.checkedArea.includes(JSON.stringify(branch.areaCode)))
        }
        this.branchsCopy = JSON.parse(JSON.stringify(this.orgBranchs))
      }
    },
    getData1 (data) {
      this.firstLevel = data
      // 点击机构一级添加区高亮
      let areasNew = this.areas // 建立新的区数组
      // 添加高亮父级
      for (let j = 0; j < data.length; j++) {
        for (let i = 0; i < areasNew.length; i++) {
          if ((data[j].areaCode + '').indexOf(areasNew[i].areaId + '') !== -1) {
            if (this.selectTypeArr.length <= 0) {
              this.itemButClick(areasNew[i])
            } else {
              for (let m = 0; m < this.selectTypeArr.length; m++) {
                if ((areasNew[i].areaId + '').indexOf(this.selectTypeArr[m]) !== -1) {
                  return
                } else {
                  // 选择区后选择一级机构后数据错乱
                  // this.itemButClick(areasNew[i])
                }
              }
            }
          }
        }
      }
    },
    getData2 (data) {
      this.secondLevel = data
    },
    getInitialData () {
      this.TopHundredData = this.$store.state.screens.TopHundred
        this.postChannel = this.$store.state.entirety.channel
        this.postKind = this.$store.state.entirety.kind
        this.postTime = this.$store.state.entirety.time
        this.postQuota = this.$store.state.entirety.quota
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.postQuota,
        channelId: this.postChannel,
        date: this.calendarData || ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showFlag = res.data
      })
      this.changeTopHundred()
    }
  },
  mounted () {
    this.getInitialData()
  },
  created () {
    this.getCompareShow()
  },
  watch: {
    TopHundredData: function (newval, oldval) {
      this.TopHundredData = newval
    },
    timeIndex: function () {
      if (this.isHeadCompany()) {
        this.activeName = '0'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.table-screes{
  margin : 0 auto;
  text-align : center;
}
.screes-titel, .screes-titel h2{
  height 0.5rem
  line-height .5rem
}
.screes-warpper{
  text-align : left;
  height: 3rem;
  overflow: hidden;
  overflow-y: scroll;
}
.screes-all span{
  margin-right : .2rem;
}
.screes-city{
  margin-top : .1rem;
  display : flex;
  justify-content : center;
}
.screes-city .van-button{
  flex : 1;
  margin : .01rem;
  font-size : 2vw;
  height : auto;
  line-height : 3;
}
.van-button--normal{
  padding : .01rem;
}
.screes-footer{
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: stretch;
}
.screes-footer>button{
  background-color: #fff;
  flex-grow:1;
  box-sizing: border-box;
  padding:.08rem 0;
}
.screes-footer>button:nth-child(1){
  border-top:1px solid #bfbfbf;
  color:#bfbfbf;
}
.screes-footer>button:nth-child(2){
  border-top:1px solid #3399ff;
  color:#fff;
  background-color: #3399ff;
}
.complete-rate{
  overflow:hidden;
  box-sizing:border-box;

}
.complete-rate>div{
  border:1px solid #f9f9f9;
  width:30%;
  float:left;
  padding:.12rem 0;
  text-align: center;
  margin-left:2.5%;
  margin-bottom:2.5%;
  border-radius:.06rem;
  background-color: #f9f9f9;
  color:#999999;
}
.sliderTick{
  overflow:hidden;
}
.sliderTick>div{
  box-sizing: border-box;
  float:left;
}
.sliderTick>div:last-child{
  float:right;
}
.screes-warpper>>>.el-slider__button{
  width: 25px;
  height: 25px;
  box-shadow: 0px 0px 15px #ddd;
  border: none;
}
.sliderCurrent{
  text-align: center;
  color:#3399ff;
}

.itemBut{
  display : flex;
  justify-content : space-around;
}
.itemBut>button{
  display : block;
  color: #1989fa;
  background-color: #fff;
  border: 1px solid #1989fa;
  padding: 0 0.05rem;
}
.itemButListH{
  color: #fff !important;
  background-color: #1989fa !important;
  border-width : 0;
}
.text {
  color:#999;
  font-weight:normal;
  margin:10px 0 8px 0;
  width:100%;
  word-break:break-all;
  text-overflow:ellipsis;//显示为省略号
  display:-webkit-box;//对象作为伸缩盒子模型显示
  -webkit-box-orient:vertical;//设置或检索伸缩盒对象的子元素的排列方式
  -webkit-line-clamp:2;//显示行数## 标题文字 ##
  overflow:hidden;
}
.screes-warpper>>>.van-collapse-item__content {
  padding: 11px!important;
}
.inputBox>>>.van-collapse-item__wrapper .van-collapse-item__content{
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-cell{
  color: #999!important;
  font-weight:normal;
  padding-left: 9px;
}
.inputBox .van-cell-group{
  display inline-block
  width:30%;
  border:none
}
.van-cell.van-field{
  background-color:#f9f9f9 !important
}
.closeicon {
  position: absolute;
  width:.21rem;
  height:.2rem
  top: 15px;
  right: 16px;
  text-align: center;
}
// 区
.itemBut{
  width: 100%;
  display : flex;
  justify-content : space-around;
}
.itemBut>button{
  display : block;
  color: #1989fa;
  background-color: #fff;
  border: 1px solid #1989fa;
  padding: 0 0.14rem;
}
.itemButListH{
  color: #fff !important;
  background-color: #1989fa !important;
  border-width : 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/screens/Screensa.vue